import './main.scss';

const FieldError = ({ error, className = '', ...rest }) => (
    <span className={`field-error ${error ? 'has-error' : ''} ${className}`} {...rest}>
        {error || ' '}
    </span>
);

export default FieldError;
